import BaseService from "./BaseService";

export default class AuthService extends BaseService {
  controllerName = "auth/account";

  async GetByExternalId(salesforceExternalId: any){
    const resp = await this.Get(`${salesforceExternalId}`, {});

    return resp.data ? resp.data : resp;
  }
}